// IMPORT
import React from "react";

import ImageGallery from "react-image-gallery";
// import stylesheet if you're not already using CSS @import
import "react-image-gallery/styles/css/image-gallery.css";

// CSS
import './CompHeadingImageGalery.css'

// CompHeadingImageGalery
export default function CompHeadingImageGalery(props) {
    return (
        <div className="CompHeadingImageGalery stack-parent">
            <div className="CompHeadingImageGalery-Images stack-child">
                <ImageGallery
                    items={props.Images}
                    autoPlay
                    showThumbnails={false}
                    showNav={false}
                    showPlayButton={false}
                    showFullscreenButton={false}
                    showBullets={true}
                    slideDuration={3000}
                />
            </div>
            <div className="CompHeadingImageGalery-Heading stack-child">
                <h1>{props.Title}</h1>
            </div>
        </div>
    )
}
